export default "__VITE_ASSET__CoGPyTNC__"